export default {
  GET_NEW_VENDOR_INFO(state, data) {
    state.newVendorInfo = data;
  },
  GET_INDEX_INFO(state, data) {
    state.carouselImgs = data.jpg;
    state.latestNews = data.notes;
  },
  QRY_SIDEBAR(state, res) {
    state.loginSidebar = res.data.data.sidebar.children;
  },
};
